import styled from '@emotion/styled'
import { COLORS } from 'styling/variables'

export const FormInputDescription = styled('span')({
  margin: 0,
  color: COLORS.mainGray,
  fontSize: 14,
  fontWeight: 'normal',
})
